<section *ngIf="url">
  <iframe [src]="url" frameborder="0" allow="autoplay"></iframe>
  <div class="borderfix"></div>
  <fa-icon class="close" (click)="close()" [icon]="iconClose"></fa-icon>
</section>
